import { isInWebView } from './nativeWebview';
import { sendMessageToNativeApp } from './nativeMessaging';
import { APP_CONSTANTS } from '../data';

/**
 * Notifies the native app that the user has entered the DMV flow.
 * Call this when the DMV transaction begins (after T&C acceptance).
 */
export const notifyDmvFlowStarted = () => {
  if (!isInWebView()) {
    return;
  }

  sendMessageToNativeApp({
    ...APP_CONSTANTS.DMV_FLOW_STARTED_MSG,
    timestamp: new Date().toISOString(),
  });
};

/**
 * Notifies the native app that the user has left the DMV flow.
 * Call this when the DMV flow exits (success, cancellation, or unmount).
 */
export const notifyDmvFlowEnded = () => {
  if (!isInWebView()) {
    return;
  }

  sendMessageToNativeApp({
    ...APP_CONSTANTS.DMV_FLOW_ENDED_MSG,
    timestamp: new Date().toISOString(),
  });
};
